import apiService from './apiService';

const STATIC_NORMES_FALLBACK = [
  { etape2_key: 'nfc_13_200', code: 'NF C 13-200', titre: 'NF C 13-200', annee: null, description: "Installations électriques à haute tension", ordre: 0, is_builtin_key: true },
  { etape2_key: 'nfc_17_200', code: 'NF C 17-200', titre: 'NF C 17-200 (2016)', annee: '2016', description: "Installations d'éclairage extérieur", ordre: 1, is_builtin_key: true },
  { etape2_key: 'nfc_15_211_2006', code: 'NF C 15-211', titre: 'NF C 15-211 (2006)', annee: '2006', description: "Installations électriques dans les locaux à usage médical - Version 2006", ordre: 2, is_builtin_key: true },
  { etape2_key: 'nfc_15_211_2017', code: 'NF C 15-211', titre: 'NF C 15-211 (2017)', annee: '2017', description: "Installations électriques dans les locaux à usage médical", ordre: 3, is_builtin_key: true },
  { etape2_key: 'nfen_50107_1', code: 'NF EN 50107-1', titre: 'NF EN 50107-1', annee: null, description: "Installations d'enseignes et de tubes lumineux à décharge fonctionnant à une tension de sortie à vide assignée supérieure à 1 kV mais ne dépassant pas 10 kV", ordre: 4, is_builtin_key: true },
  { etape2_key: 'nfc_15150_1', code: 'NF C 15-150-1', titre: 'NF C 15-150-1', annee: null, description: "Enseignes à basse tension et alimentation en basse tension des enseignes à haute tension", ordre: 5, is_builtin_key: true },
  { etape2_key: 'nfc_15_100', code: 'NF C 15-100', titre: 'NF C 15-100', annee: null, description: "Installations électriques à basse tension", ordre: 6, is_builtin_key: true },
  { etape2_key: 'nfc_13_100_2001', code: 'NF C 13-100', titre: 'NF C 13-100 (2001)', annee: '2001', description: "Postes de livraison établis à l'intérieur d'un bâtiment et alimentés par un réseau de distribution publique MT - Version 2001", ordre: 7, is_builtin_key: true },
  { etape2_key: 'nfc_13_100_2015', code: 'NF C 13-100', titre: 'NF C 13-100 (2015)', annee: '2015', description: "Postes de livraison établis à l'intérieur d'un bâtiment et alimentés par un réseau de distribution publique MT", ordre: 8, is_builtin_key: true },
];

const STATIC_ARRETES_FALLBACK = [
  { etape2_key: 'arrete_19_12_2011', arrete_code: '19/12/2011', is_builtin_key: true },
  { etape2_key: 'arrete_15_12_2011', arrete_code: '15/12/2011', is_builtin_key: true },
  { etape2_key: 'arrete_16_12_2011', arrete_code: '16/12/2011', is_builtin_key: true },
  { etape2_key: 'arrete_23_12_2011', arrete_code: '23/12/2011', is_builtin_key: true },
  { etape2_key: 'arrete_28_07_2003', arrete_code: '28/07/2003', is_builtin_key: true },
  { etape2_key: 'arrete_20_12_2011', arrete_code: '20/12/2011', is_builtin_key: true },
  { etape2_key: 'arrete_14_12_2011', arrete_code: '14/12/2011', is_builtin_key: true },
];

const LEGACY_ARRETE_LABELS = {
  arrete_19_12_2011: { title: "Arrêté du 19/12/2011", description: "Circuits électriques mis en œuvre dans le soudage électrique" },
  arrete_15_12_2011: { title: "Arrêté du 15/12/2011", description: "Installations de galvanoplastie et d'électrophorèse" },
  arrete_16_12_2011: { title: "Arrêté du 16/12/2011", description: "Dispositions particulières applicables aux laboratoires" },
  arrete_23_12_2011: { title: "Arrêté du 23/12/2011", description: "Installations électriques des équipements de travail" },
  arrete_28_07_2003: { title: "Arrêté du 28/07/2003", description: "Matériels électriques en atmosphères explosives (ATEX)" },
  arrete_20_12_2011: { title: "Arrêté du 20/12/2011", description: "Modalités de raccordement des matériels amovibles" },
  arrete_14_12_2011: { title: "Arrêté du 14/12/2011", description: "Installations d'éclairage de sécurité" },
};

/**
 * @returns {Promise<{ normes: Array, arretes: Array, fromApi: boolean }>}
 */
export async function loadEtape2ReferentielSelection() {
  try {
    const apiUrl = apiService.getApiUrl();
    const token = apiService.getToken();
    if (!apiUrl || !token) {
      throw new Error('API ou token indisponible');
    }
    const response = await fetch(`${apiUrl}/referentiels/etape-2-selection`, {
      method: 'GET',
      headers: apiService.getAuthHeaders(),
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const json = await response.json();
    if (!json.success || !json.data) {
      throw new Error('Réponse API invalide');
    }
    const normes = Array.isArray(json.data.normes) ? json.data.normes : [];
    const arretes = Array.isArray(json.data.arretes) ? json.data.arretes : [];
    if (normes.length === 0) {
      throw new Error('Liste normes vide');
    }
    return {
      normes,
      arretes: arretes.length ? arretes : STATIC_ARRETES_FALLBACK,
      fromApi: true,
    };
  } catch (e) {
    console.warn('[Etape2] Référentiel API indisponible, fallback statique:', e?.message || e);
    return {
      normes: STATIC_NORMES_FALLBACK,
      arretes: STATIC_ARRETES_FALLBACK,
      fromApi: false,
    };
  }
}

export function normeDisplayTitle(row) {
  const k = row.etape2_key;
  const fromApi = row.titre || row.code || k;
  const staticMatch = STATIC_NORMES_FALLBACK.find((s) => s.etape2_key === k);
  if (staticMatch?.titre) return staticMatch.titre;
  return fromApi;
}

export function normeDisplayDescription(row) {
  const k = row.etape2_key;
  const staticMatch = STATIC_NORMES_FALLBACK.find((s) => s.etape2_key === k);
  if (staticMatch?.description) return staticMatch.description;
  return row.description || '';
}

export function arreteDisplay(row) {
  const lab = LEGACY_ARRETE_LABELS[row.etape2_key];
  if (lab) return lab;
  const code = row.arrete_code || '';
  return {
    title: code ? `Arrêté du ${code}` : row.etape2_key,
    description: '',
  };
}

export function isLegacyArreteKey(etape2_key) {
  return Object.prototype.hasOwnProperty.call(LEGACY_ARRETE_LABELS, etape2_key);
}
